import React from 'react'
import ContentBlock from 'components/ContentBlock'
import { Form, Number as NumberInput } from 'components/forms'
import { useMutation } from 'components/graphql'
import { Col, Row } from 'react-flexbox-grid'
import { useTranslation } from 'react-i18next'
import updateProperties from 'sections/product/fragments/mutateProductProperties'
import { updateProductProperties } from 'sections/product/gql/mutation'

const ClickCollect = ({ data, formData = {} }) => {
	const [t] = useTranslation()
	const [mutate] = useMutation(updateProductProperties)

	const submitForm = ({ properties }) => {
		const { ClickCollectOrderMin } = properties
		if (ClickCollectOrderMin === 0) {
			properties.ClickCollectOrderMin = 1
		}
		updateProperties({ productId: data.id, ...properties }, mutate)
	}

	return (
		<ContentBlock>
			<Form initialValues={formData} onSubmit={submitForm} smartSubmit>
				<Row>
					<Col xs>
						<NumberInput
							label={t('product_section.fields.cc_min_order')}
							field='properties.ClickCollectOrderMin'
							precision={2}
							withControls={false}
							inline
							shrink />
						<NumberInput
							label={t('product_section.fields.cc_max_order')}
							field='properties.ClickCollectOrderMax'
							precision={2}
							withControls={false}
							inline
							shrink />
						<NumberInput
							label={t('product_section.fields.cc_lead_days_count')}
							field='properties.ClickCollectLeadDaysCount'
							withControls
							inline
							shrink />
					</Col>
				</Row>
			</Form>
		</ContentBlock>
	)
}

export default ClickCollect
